import fetch from '../fetch';

import utils from '../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'className', label: '班级姓名', width: 100},
    {key:'superOrgName', label: '二级部门', width: 140},
    {key:'orgName', label: '部门', width: 140},
    {key:'evalName1', label: '测评方 1'},
    {key:'evalScore1', label: '测评分数'},
    {key:'evalWeight1', label: '权重'},
    {key:'realScore1', label: '实际得分'},
    {key:'grade1', label: '等级'},

    {key:'finalScore', label: '最终测评分',  width: 115},
    {key:'finalGrade', label: '最终等级',  width: 115},
    {key:'termName', label: '学期',  width: 80},
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)

    return fetch.post('eval/teacher/class/total/query?'+ params.join('&'), Object.assign(defaultsParams, keywords))
    .then(response => {
        const columns = [
            {type: 'selection'},
            {key:'$index', label: '序号', width: 75},
            {key:'superOrgName', label: '二级部门', width: 140},
            {key:'orgName', label: '部门名称', width: 150},
            {key:'className', label: '班级姓名', width: 100},
            {key:'descContent', label: '描述', width: 150},
            {key:'finalScore', label: '最终测评分', width: 110},
            {key:'finalGrade', label: '最终等级', width: 90},
            {key:'termName', label: '学期', width: 130}
        ];

        (response.payload.meta.extParams.evalNameList||[]).forEach((list , index) => {
            const evalName = list
            if(evalName){
                columns.push({key:'evalScore'+ (index+1), label: `${evalName}`, width: 150});
                columns.push({key:'evalWeight'+ (index+1), label: '权重', width: 70});
                columns.push({key:'realScore'+ (index+1), label: '实际得分', width: 90});
            }
        });

        return {
            headers: utils.columns(columns),
            data: response.payload.data
        };
    })
    .then(response => {
        
        return Object.assign({
            headers: response.headers,
            result: response.data.dataList || [],
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                key: d.id,
                checked: false
            })),
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })
    });
}

/**
 * 清空本学期汇总数据
 */
const removeAllData = (importObj) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                fetch.post('eval/teacher/class/total/remove', importObj)
                .then((response) => {
                    if(response.code === 200) {
                        message.success(`共删除${response.payload.data}条记录`);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                        resolve(true);
                    } else {
                        reject();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    })
}

/** 
 * 计算最终等级
*/
const gradeCount = (importObj) => {
    return new Promise(function(resolve, reject) {
        fetch.post('eval/teacher/class/total/countFinalGradeByTerm', importObj)
        .then((response) => {
            if(response.code === 200) {
                message.success(response.message);
                resolve(true);
            } else {
                reject()
            }
        });
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    removeAllData,
    gradeCount,
    getSelection
}